export default __webpack_public_path__ + "static/media/dobbi-logo-d.4cd4201a.png";